import { ContentService } from '@blk/cwp-ng-framework';
import { AbstractRenderer, BusinessComponent, BusinessComponentOptions } from '@blk/simba';
import { ComponentData, TabData, TabUtil } from '@ddt-web/data-service';
import { ReportType } from '@ddt-web/pdf-utils';
import * as get from 'lodash/get';

import { DisclosureComponent } from '../disclaimers/disclosure-component';
import { HeadingComponent, HeadingLevel } from '../heading/heading-component';
import { FundPerformancePanelsHelper } from '../helpers/fund-performance/fund-performance-panels-helper';

export class FeesComponent extends BusinessComponent {
	private feesTab: TabData;

	constructor(
		name: string,
		public dataComponentId: string,
		private mode?: ReportType,
		public shouldIncludeTitle: boolean = false,
		private shouldReduceSpacing: boolean = false,
		public visible: boolean = true
	) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible, componentId: dataComponentId }));
	}

	public isComponentDataVisible(componentData: ComponentData): boolean {
		const isComponentDataSuccessful = componentData && componentData.success;
		this.feesTab = isComponentDataSuccessful && get(componentData, 'tabs[0]');

		return TabUtil.isTabValid(this.feesTab);
	}

	public buildComponent(componentData: ComponentData, contentSvc: ContentService): AbstractRenderer<SVGGElement>[] {
		const panels: AbstractRenderer<SVGGElement>[] = [];

		if (this.isComponentDataVisible(componentData)) {
			if (this.shouldIncludeTitle) {
				panels.push(new HeadingComponent('PDF_FEES_H2', 'Fees', HeadingLevel.H2));
				panels.push(...FundPerformancePanelsHelper.getAsOfDatePanel(this.feesTab, {}, this.shouldReduceSpacing));
			}

			panels.push(
				...FundPerformancePanelsHelper.getFundPerformancePanels(this.feesTab, contentSvc, { paddingTop: 20 }, this.mode, this.shouldReduceSpacing),
				new DisclosureComponent('PDF_FEES_DISCLAIMER', 'Fees are as of current prospectus. Source: Morningstar', {}, { paddingTop: 15, paddingBottom: 20 })
			);
		}
		return panels;
	}
}
